import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M12.5 4.891C12.5 2.751 11.479.75 9.01.75 6.541.75 5.5 2.731 5.5 4.891c0 2.12 1.02 4.359 3.51 4.359 2.449 0 3.49-2.298 3.49-4.359zm-9.846 6.562a4.063 4.063 0 0 0-.845 1.322L0 17.25h6.373l-2.692-6.663a7.689 7.689 0 0 0-1.027.866zm2.332-1.64l3.005 7.437h.259v-5.487L5.932 9.445a8.632 8.632 0 0 0-.946.368zm11.205 2.962a4.083 4.083 0 0 0-.846-1.322 7.558 7.558 0 0 0-1.012-.856l-2.458 6.083-.23.57H18l-1.809-4.475zm-4.107-3.324L9.75 11.785v5.465h.278l.458-1.133 2.544-6.296a8.64 8.64 0 0 0-.946-.37z" />
  </svg>
);

export default SvgComponent;
